
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Fragment } from 'react';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import { useRouter } from 'next/router';
import SocialMeta from '#components/common/meta/SocialMeta';
import PageSection from '#components/sections/page-section/PageSection';
import SearchGridBlock from '#components/grid-block/SearchGridBlock';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { useQueryFilters } from '#hooks/useQueryFilters';

const Search = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const {
    query: { slug },
  } = router;

  const needle = decodeURIComponent(String(slug));
  const { filters } = useQueryFilters();

  return (
    <BasePageLayout hasCanonical={false}>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Fragment>
        <SocialMeta about={{ title: t('search') }} />
        <main className="page-main-container">
          <PageSection classes="medium-down:tw-pt-4">
            <SearchGridBlock needle={needle} filters={filters} />
          </PageSection>
        </main>
      </Fragment>
    </BasePageLayout>
  );
};

export default Search;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/search/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  